import cn from 'classnames'
import * as React from 'react'
import { WrapperProps } from './MultiStepProcessIndicator.types'
import styles from './Wrapper.module.css'

export function Wrapper({ children, className }: React.PropsWithChildren<WrapperProps>) {
  return (
    <div className={cn(styles.wrapper, className)}>
      {children}
    </div>
  )
}
